import { NgModule } from '@angular/core';
import { CorrigirLinksPipe } from './corrigir-links/corrigir-links';
@NgModule({
	declarations: [CorrigirLinksPipe],
	imports: [],
	exports: [CorrigirLinksPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts